import parcelReminderShellUrl from "../assets/parcel-reminder-shell.svg?url";
import parcelTtsScripts from "./parcelTtsScripts.json";
import type { AssetManifest } from "../types/domain";

export const assetManifest: AssetManifest = {
  version: "0.1.0",
  packs: {
    "parcel-tts-v1": Object.entries(parcelTtsScripts.assets).map(([id, asset]) => ({
      id: `parcel-tts-${id}`,
      kind: "audio" as const,
      path: asset.audioSrc,
      source: "generated" as const,
      version: "v1.0",
      notes: `Bailian qwen3-tts-flash / Cherry, generated 2026-10-16. ${asset.spokenText}`
    })),
    "eva-space-v1": [
      ...[
        ["eva-space-base", "assets/eva-space/scenes/01-space-base.webp", "共享空间基础态"],
        ["eva-space-rain", "assets/eva-space/scenes/02-space-rain-night.webp", "雨夜状态同步"],
        ["eva-space-movie", "assets/eva-space/scenes/03-space-movie-active.webp", "陪看电影状态"],
        ["eva-space-memory", "assets/eva-space/scenes/04-space-memory.webp", "共同经历记忆房间"],
        ["eva-space-parcel", "assets/eva-space/scenes/05-space-parcel-event.webp", "快递空间事件"]
      ].map(([id, path, notes]) => ({
        id,
        kind: "image" as const,
        path,
        source: "generated" as const,
        version: "v1.0",
        width: 2560,
        height: 1600,
        transparentPolicy: "opaque" as const,
        notes
      })),
      ...[
        ["eva-space-memory-seaside", "assets/eva-space/memories/01-first-seaside.webp", "概念记忆：第一次去海边"],
        ["eva-space-memory-longest-day", "assets/eva-space/memories/02-longest-day.webp", "概念记忆：单日最长 860km"],
        ["eva-space-memory-rain", "assets/eva-space/memories/03-rainy-return.webp", "概念记忆：雨夜归途"],
        ["eva-space-memory-dawn", "assets/eva-space/memories/04-wait-for-dawn.webp", "概念记忆：一起等天亮"]
      ].map(([id, path, notes]) => ({
        id,
        kind: "image" as const,
        path,
        source: "generated" as const,
        version: "v1.0",
        width: 2560,
        height: 1600,
        transparentPolicy: "opaque" as const,
        notes
      }))
    ],
    "figma-v0": [
      {
        id: "parcel-reminder-shell", kind: "image", path: parcelReminderShellUrl,
        source: "figma", version: "v1.0", width: 768, height: 564, transparentPolicy: "preserve",
        notes: "User supplied Untitled.zip, 2026-10-16, SVG node 1:45310. Original EVA, glass hands and shadow preserved; edge glow narrowed with SVG color/opacity gradients to match follow-up screenshot; placeholder content removed for live HTML text/button."
      },
      {
        id: "traditional-day-parcel",
        kind: "figma-frame",
        path: "assets/figma/traditional-day-parcel.png",
        source: "figma",
        version: "v1.0",
        sourceUrl: "https://www.figma.com/design/o3p43vCghwtG8R8dPiKKHV/Untitled?node-id=1-44890",
        figmaFileKey: "o3p43vCghwtG8R8dPiKKHV",
        figmaNodeId: "1:44890",
        width: 2560,
        height: 1600,
        transparentPolicy: "opaque",
        notes: "Figma任务提示白天传统桌面原始导出；顶部示例胶囊和时间由交互层覆盖。"
      },
      {
        id: "parcel-eva-head",
        kind: "image",
        path: "assets/figma/parcel-eva-head.svg",
        source: "procedural",
        version: "v1.0",
        width: 120,
        height: 120,
        transparentPolicy: "preserve",
        notes: "根据用户卡片参考重建的青蓝紫色EVA头部矢量；不是Figma原图标导出。"
      },
      {
        id: "desktop-standard-frame",
        kind: "figma-frame",
        path: "assets/figma/traditional-desktop.webp",
        source: "figma",
        version: "v0.3",
        width: 2560,
        height: 1600,
        transparentPolicy: "opaque",
        notes: "User-provided traditional desktop SVG used as the standard desktop middle visual baseline."
      },
      {
        id: "traditional-carwash-navigation",
        kind: "image",
        path: "assets/figma/traditional-carwash-navigation.webp",
        source: "generated",
        version: "v0.1",
        width: 1415,
        height: 1111,
        transparentPolicy: "opaque",
        notes: "Generated right-side navigation map showing route to a car wash shop for the standard desktop."
      },
      {
        id: "traditional-parcel-navigation",
        kind: "image",
        path: "assets/figma/traditional-parcel-navigation.webp",
        source: "generated",
        version: "v0.1",
        width: 1415,
        height: 1111,
        transparentPolicy: "opaque",
        notes: "Generated right-side navigation map showing an on-route parcel station waypoint and home as the final destination for the standard desktop."
      },
      {
        id: "traditional-charging-navigation",
        kind: "image",
        path: "assets/figma/traditional-charging-navigation.webp",
        source: "generated",
        version: "v0.2",
        width: 1415,
        height: 1111,
        transparentPolicy: "opaque",
        notes: "Generated standard desktop charging route map with destination marker and destination label removed for component overlays."
      },
      {
        id: "traditional-dock",
        kind: "image",
        path: "assets/figma/traditional-dock.png",
        source: "figma",
        version: "v0.1",
        width: 2560,
        height: 160,
        transparentPolicy: "preserve",
        notes: "User-provided dock image for the standard desktop bottom navigation."
      },
      {
        id: "desktop-ai-frame",
        kind: "figma-frame",
        path: "assets/figma/ai-os-desktop.webp",
        source: "figma",
        version: "v0.1",
        sourceUrl: "https://www.figma.com/design/o3p43vCghwtG8R8dPiKKHV/Untitled?node-id=1-36980",
        figmaFileKey: "o3p43vCghwtG8R8dPiKKHV",
        figmaNodeId: "1:36980",
        width: 2560,
        height: 1600,
        transparentPolicy: "opaque",
        notes: "User-exported SVG visual baseline for the AI OS desktop."
      },
      {
        id: "alipay-parcel",
        kind: "image",
        path: "assets/figma/night-ai/parcel-detail-screenshot.webp",
        source: "alipay-screenshot",
        version: "v0.1",
        width: 1200,
        height: 2467,
        safePadding: 16,
        transparentPolicy: "opaque",
        notes: "User-supplied parcel detail phone screenshot shown from the parcel card."
      },
      {
        id: "alipay-carwash",
        kind: "image",
        source: "alipay-screenshot",
        version: "placeholder",
        safePadding: 16,
        transparentPolicy: "opaque"
      },
      {
        id: "alipay-charging",
        kind: "image",
        source: "alipay-screenshot",
        version: "placeholder",
        safePadding: 16,
        transparentPolicy: "opaque"
      },
      {
        id: "alipay-parking",
        kind: "image",
        source: "alipay-screenshot",
        version: "placeholder",
        safePadding: 16,
        transparentPolicy: "opaque"
      },
      {
        id: "alipay-refuel",
        kind: "image",
        source: "alipay-screenshot",
        version: "placeholder",
        safePadding: 16,
        transparentPolicy: "opaque"
      }
    ],
    "video-interaction-v1": [
      {
        id: "tomato-projectile-red",
        kind: "image",
        path: "assets/figma/night-ai/video-companion/interactions/tomato/tomato-red.webp",
        source: "generated",
        version: "v1.0",
        width: 512,
        height: 512,
        safePadding: 24,
        transparentPolicy: "preserve",
        notes: "Generated transparent ordinary tomato projectile for the video companion reaction demo."
      },
      {
        id: "tomato-projectile-gold",
        kind: "image",
        path: "assets/figma/night-ai/video-companion/interactions/tomato/tomato-gold.webp",
        source: "generated",
        version: "v1.0",
        width: 512,
        height: 512,
        safePadding: 24,
        transparentPolicy: "preserve",
        notes: "Generated transparent golden third-hit tomato projectile with close sparkle accents."
      },
      {
        id: "tomato-impact-splash",
        kind: "image",
        path: "assets/figma/night-ai/video-companion/interactions/tomato/tomato-splash.webp",
        source: "generated",
        version: "v1.0",
        width: 768,
        height: 768,
        safePadding: 24,
        transparentPolicy: "preserve",
        notes: "Generated transparent family-friendly tomato sauce impact splash."
      },
      {
        id: "tomato-impact-splash-gold",
        kind: "image",
        path: "assets/figma/night-ai/video-companion/interactions/tomato/tomato-splash-gold.webp",
        source: "generated",
        version: "v1.0",
        width: 768,
        height: 768,
        safePadding: 24,
        transparentPolicy: "preserve",
        notes: "Generated transparent golden tomato juice impact splash for the third-hit easter egg."
      },
      {
        id: "tomato-trigger-video",
        kind: "video",
        path: "assets/video/video-companion/interactions/tomato/kuangbiao-villain-0-16.mp4",
        source: "generated",
        version: "v1.0",
        sourceUrl: "https://www.bilibili.com/video/BV1SFZxBhEJ5/",
        width: 1280,
        height: 720,
        transparentPolicy: "opaque",
        notes: "User-selected 0-16 second excerpt prepared as the villain-scene trigger video."
      },
      {
        id: "tomato-throw-whoosh",
        kind: "audio",
        path: "assets/audio/video-companion/interactions/tomato/tomato-throw-whoosh.wav",
        source: "procedural",
        version: "v1.0",
        notes: "Deterministically synthesized 48 kHz stereo projectile whoosh, 0.58 seconds."
      },
      {
        id: "tomato-impact",
        kind: "audio",
        path: "assets/audio/video-companion/interactions/tomato/tomato-impact.wav",
        source: "procedural",
        version: "v1.0",
        notes: "Deterministically synthesized 48 kHz stereo wet tomato impact, 0.76 seconds."
      },
      {
        id: "tomato-impact-gold",
        kind: "audio",
        path: "assets/audio/video-companion/interactions/tomato/tomato-impact-gold.wav",
        source: "procedural",
        version: "v1.0",
        notes: "Deterministically synthesized 48 kHz stereo golden impact with reward chimes, 1.34 seconds."
      }
    ],
    "movie-gacha-v1": [
      {
        id: "movie-gacha-inception-art",
        kind: "image",
        path: "assets/figma/night-ai/video-companion/gacha/inception-dream.webp",
        source: "generated",
        version: "v1.0",
        width: 1600,
        height: 900,
        transparentPolicy: "opaque",
        notes: "Generated original folding-city science-fiction artwork for the Inception candidate in the movie gacha demo."
      }
    ],
    "character-voice-v1": [
      {
        id: "character-voice-gaoqiqiang",
        kind: "audio",
        path: "assets/audio/character-voice-gaoqiqiang.mp3",
        source: "user-provided",
        version: "v1.1",
        notes: "User-provided character dialogue audio for the click-to-play demo scene."
      }
    ]
  }
};

export function getAsset(id: string, packId = "figma-v0") {
  return assetManifest.packs[packId]?.find((asset) => asset.id === id);
}
